import React, { FC, Fragment } from 'react';
import { Box, Text, Radio } from '@bechtel/gds';
import { useField } from 'formik';
import { DrawerSubHeaderStyled } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';
import { searchScopeList } from '../form-state';
import { useLingui } from '@lingui/react';
import { ListSelectionStyled } from './styled';

interface SearchScopeProps {
  name: string;
}

export const SearchScope: FC<SearchScopeProps> = ({ name }) => {
  const { i18n } = useLingui();
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;

  return (
    <Fragment>
      <DrawerSubHeaderStyled>
        <Trans>Welds</Trans>
      </DrawerSubHeaderStyled>
      {searchScopeList.map((scopeItem) => {
        return (
          <ListSelectionStyled
            data-testid={`scope-item-${scopeItem.id}`}
            key={scopeItem.id}
            onClick={() => {
              setValue(scopeItem.value);
            }}
          >
            <Box mr={{ sm: '500' }}>
              <Radio checked={field.value === scopeItem.value} readOnly />
            </Box>
            <Text color="grey.1000" size="400">
              {i18n._(scopeItem.label)}
            </Text>
          </ListSelectionStyled>
        );
      })}
    </Fragment>
  );
};
